export default __webpack_public_path__ + "static/media/1.eec866de.jpg";